import React, { useEffect, useCallback } from 'react';
import * as _ from 'lodash';
import { Form, Button, Input } from 'antd';
import styled from 'styled-components';

const WorkflowAuth = ({onSubmit, onClose}) => {

  const [form] = Form.useForm();

  const formItemLayout = {
    labelCol: {
      xs: { span: 8, offset: 2 },
      sm: { span: 8, offset: 2 },
    },
    wrapperCol: {
      xs: { span: 10 },
      sm: { span: 10 },
    },
  };

  const handleSubmit = useCallback(async () => {

    const row = await form.validateFields();

    onSubmit(row.username, row.password);
    form.resetFields();

  }, [form, onSubmit])

  return (
    <Container>
      <Form
        form={form}
        {...formItemLayout}
        onFinish={handleSubmit}
        labelAlign="left"
        autoComplete="off"
        hideRequiredMark
      >
        <Form.Item label="Username" name="username" rules={[
          {
            required: true,
            whitespace: true,
            message: 'Username required!'
          }
        ]}
          style={{ marginBottom: '8px', merginLeft: 0 }}
        >
          <Input style={{ width: 225 }} ref={(input) => input && input.focus()} />
        </Form.Item>
        <Form.Item
          label="Password" 
          name="password"
          rules={[
            {
              required: true,
              whitespace: true,
              message: 'Password required!'
            }
          ]} style={{ marginBottom: '8px' }}>
            <Input.Password visibilityToggle={false} style={{ width: 225 }} />
        </Form.Item>
        <ButtonContainer>
          <Button
              style={{width: '100px', marginRight: '10px'}}
              onClick={() => { form.resetFields(); onClose(); }}
            >
              Cancel
            </Button>
            <Button
              style={{width: '100px'}}
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
        </ButtonContainer>
      </Form>
    </Container>
  )
}

const Container = styled.div`
  width: 350px;
  height: 120px;
  .ant-col-sm-offset-2 {
    margin-left: 0;
  }
`

const ButtonContainer = styled.div`
  float: right;
  margin-top: 5px;
`

export default WorkflowAuth;
